<script lang="ts">
	import { PrismicPreview } from '@prismicio/svelte/kit';
	import { page } from '$app/state';
	import { repositoryName } from '$lib/prismicio';
	import Navigation from '$lib/components/Navigation.svelte';
	import { beforeNavigate, onNavigate } from '$app/navigation';
	import { onMount } from 'svelte';
	import { menuOpen, pageScrolled, scrollDistance } from '$lib/helpers/app.stores';
	import Footer from '$lib/components/Footer.svelte';
	import { env } from '$env/dynamic/public';

	let { children } = $props();

	let scrolled: boolean = $state(false);

	const getCanonicalUrl = (path: string): string => {
		return `${env.PUBLIC_ROOT_URL}${path}`;
	};
	const canonical = $state(getCanonicalUrl(page.url.pathname));

	beforeNavigate(() => {
		menuOpen.set(false);
	});

	onNavigate((navigation) => {
		if (!document.startViewTransition) return;

		return new Promise((resolve) => {
			document.startViewTransition(async () => {
				resolve();
				await navigation.complete;
			});
		});
	});

	onMount(() => {
		const handleScroll = () => {
			scrolled = window.scrollY > 0;
			pageScrolled.set(window.scrollY > 0);
			scrollDistance.set(window.scrollY);
		};

		window.addEventListener('scroll', handleScroll);
		handleScroll(); // run once on mount

		return () => window.removeEventListener('scroll', handleScroll);
	});
</script>

<svelte:head>
	{#if page.data.meta_title}
		<title>{page.data.meta_title}</title>
	{:else}
		<title>{page.data.title}</title>
	{/if}
	{#if page.data.meta_description}
		<meta name="description" content={page.data.meta_description} />
	{/if}
	{#if page.data.meta_title}
		<meta property="og:title" content={page.data.meta_title} />
	{/if}
	{#if page.data.meta_image}
		<meta property="og:image" content={page.data.meta_image} />
		<meta name="twitter:card" content="summary_large_image" />
	{/if}

	{#if canonical}
		<link rel="canonical" href={canonical} />
		<meta property="og:url" content={canonical} />
	{/if}

	<style>
		@import '/src/styles/app.scss';
	</style>
</svelte:head>
<main class:scrolled>
	{#if page.data.navigation}
		<Navigation navigation={page.data.navigation} />
	{/if}

	{@render children()}

	<Footer socials={page.data.socials} />
</main>
<PrismicPreview {repositoryName} />
